
<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
        <form [formGroup]="driverForm" (keydown.enter)="$event.preventDefault()">
            <div>
                <h1 *ngIf="source !== 'modal'" class="heading">
                    {{driverId ? 'Edit' : 'Add'}}
                </h1>
                <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                <h2 class="heading">
                    General Information
                </h2>
                <p class="text-sm-light">
                    Please provide the following information.
                </p>
            </div>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 p-3 rounded-lg bg-white dark:bg-transparent">
                <div class="space-y-1">
                    <label class="subheading">
                        First Name <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="firstName" type="text" />
                        </div>
                    </div>
                    <div *ngIf="submitted && form.firstName.errors">
                        <p *ngIf="form.firstName.errors.required" class="pt-1 text-red-600 text-xs">
                            First Name is required
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Middle Name
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="middleName" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Last Name <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="lastName" type="text" value="Doe" />
                        </div>
                    </div>
                    <div *ngIf="submitted && form.lastName.errors">
                        <p *ngIf="form.lastName.errors.required" class="pt-1 text-red-600 text-xs">
                            Last Name is required
                        </p>
                    </div>
                </div>

                <div class="space-y-1">
                    <label class="subheading">
                        Display Name
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="displayName" type="text" value="Doe" />
                        </div>
                    </div>
                </div>
    
                <ng-container formGroupName="address">
    
                    <div class="space-y-1">
                        <label class="subheading">
                            Address <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <input googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeOwnerAddress()" formControlName="name" type="text"
                                placeholder="Enter the address" />
                            <!-- <div
                                *ngIf="submitted && (addressForm.get('name')?.errors || addressForm.get('coords')?.errors || addressForm.get('coords')?.value?.length === 0)">
                                <p *ngIf="(addressForm.get('name')?.errors?.required || 
                                              addressForm.get('coords')?.errors?.required || 
                                              addressForm.get('coords')?.value?.length === 0)" class="pt-1 text-red-600 text-xs">
                                    Address is required
                                </p>
                            </div> -->
                             <div *ngIf="submitted">
                                <div class="error">
                                    <p *ngIf="addressForm.get('name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                        Address is required
                                    </p>
                                    <p *ngIf="addressForm?.errors?.invalidAddress"
                                        class="mt-2 text-red-600 text-xs">
                                        Invalid address (select from the dropdown)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <!-- city -->
                    <div class="space-y-1">
                        <label class="subheading">
                            City <span class="text-red-600">*</span>
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="city" type="text" value="New York" />
                            </div>
                        </div>
    
                        <div *ngIf="submitted && addressForm.get('city')?.errors">
                            <p *ngIf="addressForm.get('city')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                City is required
                            </p>
                        </div>
                    </div>
    
                    <!-- State -->
                    <div class="space-y-1">
                        <label class="subheading">
                            State <span class="text-red-600">*</span>
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="state" type="text" />
                            </div>
                        </div>
    
                        <div *ngIf="submitted && addressForm.get('state')?.errors">
                            <p *ngIf="addressForm.get('state')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                State is required
                            </p>
                        </div>
                    </div>
    
                    
                   
    
                </ng-container>
    
    
                <div class="space-y-1">
                    <label class="subheading">
                        Contact Number <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="contactNumber" type="text" value="814 718 0908" />
                        </div>
                    </div>
                
                    <div *ngIf="submitted && form.contactNumber.errors">
                        <p *ngIf="form.contactNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Contact Number is required
                        </p>
                        <p *ngIf="submitted && form.contactNumber.errors?.minlength || submitted && form.contactNumber.errors.maxlength"
                            class="pt-1 text-red-600 text-xs">
                            Minimum 10 digits are required and maximum 13 digits are allowed
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Phone Number <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="phoneNumber" type="text" value="814 718 0908" />
                        </div>
                    </div>
    
                    <div *ngIf="submitted && form.phoneNumber.errors">
                        <p *ngIf="form.phoneNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Phone Number is required
                        </p>
                        <p *ngIf="submitted && form.phoneNumber.errors?.minlength || submitted && form.phoneNumber.errors.maxlength"
                            class="pt-1 text-red-600 text-xs">
                            Minimum 10 digits are required and maximum 13 digits are allowed
                        </p>
                    </div>
                </div>
                
    
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="email" type="email" value="zain.qa@yamsol.com" />
                        </div>
                    </div>
    
                    <div *ngIf="submitted && form.email.errors">
                        <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                            Email is required
                        </p>
                        <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                                Invalid Email format
                            </p>
                    </div>
                </div>
    
                <!-- Driver Signature -->
                <div class="space-y-1 col-span-2">
                    <label class="subheading">
                        Driver Signature
                    </label>
                    <div class="flex items-center gap-2 mt-1">
                        <input #driverSignatureImageInput type="file" accept="image/*"
                            (change)="uploadDocumentImages(driverSignatureImageInput, driverForm.get('signature'))" />
                        <button type="button" class="btn btn-primary whitespace-nowrap flex items-center gap-1.5" (click)="openSignatureModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M2 21c3.5-3 6.5-3 10 0s6.5-1.5 9.5-3" />
                            </svg>
                            <span>Draw Signature</span>
                        </button>
                    </div>

                    <!-- Selected / Output Display -->
                    <div class="flex items-center gap-2 my-1" *ngIf="driverForm.get('signature')?.value">
                        <a target="_blank" [href]="driverForm.get('signature')?.value"
                            class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800 break-all">
                            {{ getFileName(driverForm.get('signature')?.value) }}
                        </a>
                        <button type="button" [appCopyToClipboard]="driverForm.get('signature')?.value" copyLabel="document link" copyTooltip="Copy link"
                            class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                            </svg>
                        </button>
                        <button type="button" (click)="deleteFile(driverForm.get('signature'), driverSignatureImageInput)"
                            class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none cursor-pointer">
                            <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clip-rule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Profile Image -->
                <div class="space-y-1">
                    <label class="subheading">
                        Profile Image
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                                <!-- Display the profile logo or a placeholder -->
                                <img src="{{profileImageURL ? profileImageURL : 'assets/images/profileImagePlaceholder.png' }}"
                                    alt="Profile Image" class="relative h-32 w-32 rounded-full border border-main-base" />
                                <label for="Profile"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                    <span>Change</span>
                                    <input #logoInput type="file" accept="image/*" style="width: 100%;" [hidden]="true"
                                        (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                        class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
    
            </section>
            <div class="mt-4">
                <h2 class="heading">
                    Driver's Documents
                </h2>
                <p class="text-sm-light">
                    Please provide the following information and documents.
                </p>
            </div>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 p-3 rounded-lg bg-white dark:bg-transparent">
    
                <ng-container formGroupName="driverLicense">
                    <div class="space-y-1">
                        <label class="subheading">
                            Front of Driver's License
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <!-- <input #licenseImage accept="image/*" type="file"
                                    (change)="uploadDriverLicenseImage(licenseImage)" /> -->
                                <input #driverLicenseImageInput type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(driverLicenseImageInput, driverLicense.get('image'))" />
    
                                <!-- Show the selected file name if image selected -->
                                <div class="flex items-center justify-between my-1"
                                    *ngIf="driverLicense.get('image')?.value">
                                    <a target="_blank" [href]="driverLicense.get('image')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(driverLicense.get('image')?.value) }}
                                    </a>
                                    <div class="flex items-center gap-2">
                                    <button type="button" [appCopyToClipboard]="driverLicense.get('image')?.value" copyLabel="document link" copyTooltip="Copy link"
                                        class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                        </svg>
                                    </button>
                                    <button type="button" (click)="deleteFile(driverLicense.get('image'), driverLicenseImageInput)"
                                        class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- License Number -->
                    <div class="space-y-1">
                        <label class="subheading">
                            License Number 
                            <span class="text-red-600">*</span>
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="number" type="text" />
                            </div>
                        </div>
                        <div *ngIf="submitted && driverLicense.get('number')?.errors">
                            <p *ngIf="driverLicense.get('number')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                License Number is required
                            </p>
                        </div>
                    </div>
                    <!-- License Issue Date -->
                    <div class="space-y-1">
                        <label class="subheading">
                            License Issue Date 
                            <span class="text-red-600">*</span>
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" name="time" id="time" formControlName="issueDate"
                                    [owlDateTime]="issueDate" [owlDateTimeTrigger]="issueDate"
                                    [max]="driverLicense.get('expireDate')?.value" [readOnly]="true"  />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(driverLicense.get('issueDate'))"
                                    #issueDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && driverLicense.get('issueDate')?.errors">
                            <p *ngIf="driverLicense.get('issueDate')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                License Issue Date is required
                            </p>
                        </div>
                    </div>
    
                    <!-- License Expiration Date -->
                    <div class="space-y-1">
                        <label class="subheading">
                            License Expiration Date 
                            <span class="text-red-600">*</span>
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <!-- <input [owlDateTimeTrigger]="expireDate" (ngModelChange)="onExpireDateChange($event)"
                                    formControlName="preLicenseExpireDate" [owlDateTime]="expireDate" type="text" />
                                <owl-date-time [pickerType]="'calendar'" #expireDate></owl-date-time> -->
    
                                <input type="text" name="time" id="time" formControlName="expireDate"
                                    [owlDateTime]="expireDate" [owlDateTimeTrigger]="expireDate"
                                    [min]="driverLicense.get('issueDate')?.value" [readOnly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(driverLicense.get('expireDate'))"
                                    #expireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && driverLicense.get('expireDate')?.errors">
                            <p *ngIf="driverLicense.get('expireDate')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                License Expiration Date is required
                            </p>
                             <p *ngIf="driverLicense.get('expireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                License Expiration Date must be after License Issue Date 
                            </p>
                        </div>
                    </div>
                    <!-- License State Issued -->
                    <div class="space-y-1">
                        <label class="subheading">
                            License State Issued 
                            <!-- <span class="text-red-600">*</span> -->
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="stateIssue" type="text" />
                            </div>
                        </div>
    
                        <!-- <div *ngIf="submitted && driverLicense.get('stateIssue')?.errors">
                            <p *ngIf="driverLicense.get('stateIssue')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                License State Issued is required
                            </p>
                        </div> -->
                    </div>
                </ng-container>
    
                <!-- Date of Birth -->
                <div class="space-y-1">
                    <label class="subheading">
                        Date of Birth <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <!-- <input formControlName="dob" type="text" /> -->
                            <input type="text" name="time" id="time" formControlName="dob" [owlDateTime]="dob"
                                [owlDateTimeTrigger]="dob" [min]="getTimeRestrictions().min" [max]="getTimeRestrictions().max" [readOnly]="true" />
                            <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(form.dob)"
                                #dob></owl-date-time>
                        </div>
                    </div>
    
                    <div *ngIf="submitted && form.dob.errors">
                        <p *ngIf="form.dob.errors.required" class="pt-1 text-red-600 text-xs">
                            Date of Birth is required
                        </p>
                    </div>
                </div>
                <!-- Languages Spoken -->
                <div class="space-y-1">
                    <label class="subheading">
                        Spoken Languages <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="languageSpoken" type="text" />
                        </div>
                    </div>
    
                    <div *ngIf="submitted && form.languageSpoken.errors">
                        <p *ngIf="form.languageSpoken.errors.required" class="pt-1 text-red-600 text-xs">
                            Spoken Languages are required
                        </p>
                    </div>
                </div>
    
                <!-- attestation -->
                <div class="space-y-1">
                    <label class="subheading">
                        Attestation <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input #attestation type="file" accept="Image/*"
                                (change)="uploadDocumentImages(attestation, driverForm.get('attestation'))" />

                            <div class="flex items-center justify-between my-1"
                            *ngIf="driverForm.get('attestation')?.value">
                            <a target="_blank" [href]="driverForm.get('attestation')?.value"
                                class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                {{ getFileName(driverForm.get('attestation')?.value) }}
                            </a>
                            <div class="flex items-center gap-2">
                            <button type="button" [appCopyToClipboard]="driverForm.get('attestation')?.value" copyLabel="document link" copyTooltip="Copy link"
                                class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                </svg>
                            </button>
                            <button type="button" (click)="deleteFile(driverForm.get('attestation'), attestation)"
                                class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd"></path>
                                </svg>
                            </button>
                            </div>
                        </div>

                        </div>
                    </div>

                    <div *ngIf="submitted && driverForm.get('attestation')?.errors">
                        <p *ngIf="driverForm.get('attestation')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Attestation is required
                        </p>
                    </div>
                </div>


            <!--formGroupName  examinations -->

                <ng-container formGroupName="examinations">
                    <!-- phyExamImage -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Latest Physical Exam
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                            
    
                                <input #phyExamImage type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(phyExamImage, examinations.get('phyExamImage'))" />
    
                                <!-- <div *ngIf="examinations.get('phyExamImage')?.value">
                                    <a target="_blank" [href]="examinations.get('phyExamImage')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(examinations.get('phyExamImage')?.value) }}
                                    </a>
                                </div> -->
    
                                <div class="flex items-center justify-between my-1"
                                *ngIf="examinations.get('phyExamImage')?.value">
                                <a target="_blank" [href]="examinations.get('phyExamImage')?.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(examinations.get('phyExamImage')?.value) }}
                                </a>
                                <div class="flex items-center gap-2">
                                <button type="button" [appCopyToClipboard]="examinations.get('phyExamImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button" (click)="deleteFile(examinations.get('phyExamImage'), phyExamImage)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>

                    <!-- phyExamDate -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Latest Physical Exam Date
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <!-- <input [owlDateTimeTrigger]="phyExamDate" (ngModelChange)="onPhyExameDateChange($event)"
                                    formControlName="prePhyExamDate" [owlDateTime]="phyExamDate" type="text" />
                                <owl-date-time [pickerType]="'calendar'" #phyExamDate></owl-date-time> -->
    
                                <input type="text" name="time" id="time" formControlName="phyExamDate"
                                    [owlDateTime]="phyExamDate" [owlDateTimeTrigger]="phyExamDate"
                                    [max]="examinations.get('phyExamExpireDate')?.value" [readOnly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(examinations.get('phyExamDate'))"
                                    #phyExamDate></owl-date-time>
                            </div>
    
                        </div>
                    </div>
    
                    <!-- phyExamExpireDate -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Latest Physical Exam Expiration Date
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                
    
                                <input type="text" name="time" id="time" formControlName="phyExamExpireDate"
                                    [owlDateTime]="phyExamExpireDate" [owlDateTimeTrigger]="phyExamExpireDate"
                                    [min]="examinations.get('phyExamDate')?.value" [readOnly]="true" />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(examinations.get('phyExamExpireDate'))"
                                    #phyExamExpireDate></owl-date-time>
                            </div> 
                        </div>
                         <div *ngIf="submitted && examinations.get('phyExamExpireDate')?.errors">
                             <p *ngIf="examinations.get('phyExamExpireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                Latest Physical Exam Expiration Date must be after  Latest Physical Exam Date 
                            </p>
                        </div>
                    </div>
    
                    <!-- drugTestImage -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Drug Test
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input #drugTestImage type="file" accept="Image/*"
                                    (change)="uploadDocumentImages(drugTestImage, examinations.get('drugTestImage'))" />
    
                                <!-- <div *ngIf="examinations.get('drugTestImage')?.value">
                                    <a target="_blank" [href]="examinations.get('drugTestImage')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(examinations.get('drugTestImage')?.value) }}
                                    </a>
                                </div> -->
    
                                <div class="flex items-center justify-between my-1"
                                *ngIf="examinations.get('drugTestImage')?.value">
                                <a target="_blank" [href]="examinations.get('drugTestImage')?.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(examinations.get('drugTestImage')?.value) }}
                                </a>
                                <div class="flex items-center gap-2">
                                <button type="button" [appCopyToClipboard]="examinations.get('drugTestImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 dark:border-zinc-600 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-white hover:text-primary hover:border-primary dark:hover:text-primary dark:hover:border-primary flex items-center justify-center outline-none focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button type="button" (click)="deleteFile(examinations.get('drugTestImage'), drugTestImage)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>

                    </div>

                    <!-- Drug Date -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Drug Test Date
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" name="time" id="time" formControlName="drugTestDate"
                                    [owlDateTime]="drugTestDate" [owlDateTimeTrigger]="drugTestDate"
                                    [max]="examinations.get('drugTestExpireDate')?.value" [readOnly]="true"  />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(examinations.get('drugTestDate'))"
                                    #drugTestDate></owl-date-time>
                            </div>
                        </div>
    
                        <div *ngIf="submitted && examinations.get('drugTestDate')?.errors">
                            <p *ngIf="examinations.get('drugTestDate')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                Drug Test Date is required
                            </p>
                        </div>
                    </div>
    
                    <!-- Drug Date Expiration date -->
                    <div class="space-y-1">
                        <label class="subheading">
                            Drug Test Expiration Date
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" name="time" id="time" formControlName="drugTestExpireDate"
                                    [owlDateTime]="drugTestExpireDate" [owlDateTimeTrigger]="drugTestExpireDate"
                                    [min]="examinations.get('drugTestDate')?.value" [readOnly]="true"  />
                                <owl-date-time [pickerType]="'calendar'"
                                    (afterPickerClosed)="onDateChange(examinations.get('drugTestExpireDate'))"
                                    #drugTestExpireDate></owl-date-time>
                            </div>
                        </div>
                        <div *ngIf="submitted && examinations.get('drugTestExpireDate')?.errors">
                             <p *ngIf="examinations.get('drugTestExpireDate')?.errors?.dateMismatch"
                                class="pt-1 text-red-600 text-xs">
                                Drug Test Expiration Date must be after Drug Test Date 
                            </p>
                        </div>
                    </div>
                </ng-container>
    
    
                <div class="space-y-1">
                    <label class="subheading">
                        Convicted of child abuse or felony in last 5 years?
                    </label>
                    <div>
                        <div>
                            <select formControlName="abuse">
                                <option [value]="true">Yes</option>
                                <option [value]="false">No</option>
                            </select>
                        </div>
                        
                    </div>
                </div>
    
    
                <div class="space-y-1">
                    <label class="subheading">
                        Any vehicle violations in last 3 years?
                    </label>
                    <div>
                        <div>
                            <select formControlName="violations">
                                <option [value]="true">Yes</option>
                                <option [value]="false">No</option>
                            </select>
                        </div>
                       
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Service Area(s)
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="serviceAreas" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div>
                        <div>
                            <select formControlName="isActive">
                                <option [ngValue]="true">Active</option>
                                <option [ngValue]="false">Inactive</option>
                            </select>
                        </div>
                        
                    </div>
                </div>
            </section>
    
    
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <!-- <button class="btn-outline btn-outline-secondary">
                    Approve
                </button> -->
                <button type="button" (click)="onSave()" class="btn btn-secondary">
                    {{driverId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>    
</div>

<app-trip-signature-modal
  *ngIf="signatureModalObj"
  [trip]="signatureModalObj"
  [source]="'driver'"
  (closeModal)="onCloseSignatureModal($event)">
</app-trip-signature-modal>